module.exports = __webpack_public_path__ + "static/media/xtptp_m.1a0c959b.png";